import React from 'react';
import { CalendarFormat } from '@fitogram/react-calendar';
import { EventListWrapper } from '../EventList';

export const Dashboard = () => <EventListWrapper calendarFormat={CalendarFormat.week} />;
